import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    details: {
      fontSize: 17
    },
    flexContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexDirection: 'column',
      maxWidth: '500px',
      backgroundColor: 'white',
      minHeight: '80vh',
      borderRadius: '10px'
    },
    BtnsContainer: {
      display: 'flex',
      width: '100%',
      gap: '15px',
      justifyContent: 'space-evenly',
      flexWrap: 'wrap'
    },
    container: {
      marginTop: '20px',
      paddingBottom: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderRadius: '5px',
      maxHeight: '34vh',
      width: '95%',
      overflowX: 'hidden',
      overflowY: 'auto',
      background: 'white',
      '&::-webkit-scrollbar': {
        width: '2vh',
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
        backgroundColor: '#F5F5F5',
        borderRadius: '3px'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '3px',
        backgroundImage:
          '-webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));'
      }
    },
    containerList: {
      borderRadius: '5px',
      height: '55vh',
      minHeight: '45vh',
      maxHeight: '80vh',
      width: '87%',
      overflowX: 'hidden',
      overflowY: 'scroll',
      border: '0.5px solid #004BB1',
      background: 'white',
      '&::-webkit-scrollbar': {
        width: '10px',
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
        backgroundColor: '#F5F5F5',
        borderRadius: '5x'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '5px',
        backgroundImage:
          '-webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));'
      }
    },
    supplierBtn: {
      cursor: 'pointer',
      marginBottom: '20px',
      paddingLeft: '20px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '1rem',
      fontFamily: 'Poppins,sans-serif',
      lineHeight: '1.5',
      background: '#E2E8F0',
      width: '80%',
      height: '48px',
      minHeight: '48px',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      boxShadow:
        '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)'
    },
    redText: {
      color: 'red',
      fontWeight: 'bold'
    },
    boldText: {
      fontWeight: 'bold'
    }
  })
)
